import { useEffect, useState } from "react";

import useStyles from "./select-input.styles";

const SelectInput = (props: any) => {
  const { register, ...otherProps } = props;
  const { label, name, errors, values, disabled } = otherProps;

  const [focused, setFocused] = useState(false);
  const [selected, setSelected] = useState(false);

  const classes = useStyles({ focused, selected, disabled });

  let value = values[name];
  let error = errors[name];

  if (name.includes(".")) {
    let nameArr = name.split(".");
    const reducer = (acc: any, cur: any) => acc?.[cur];
    value = nameArr.reduce(reducer, values);
    error = nameArr.reduce(reducer, errors);
  }

  const showFeedback = value?.toString().trim().length > 0 || error;

  useEffect(() => {
    if (value?.trim().length !== 0) {
      setSelected(true);
    } else {
      setSelected(false);
    }
  }, [value]);

  return (
    <div className={classes.inputContainer}>
      {showFeedback ? (
        <div className={classes.errorMessage}>{error?.message}</div>
      ) : null}
      <select
        {...otherProps}
        autoComplete="chrome-off"
        id={name}
        className={classes.input}
        {...register(name)}
        onFocus={() => {
          setFocused(true);
        }}
        onBlur={() => {
          setFocused(false);
        }}
      />
      <label className={classes.label}>{label}</label>
    </div>
  );
};

export default SelectInput;
